module.exports = __webpack_public_path__ + "img/pc_index12.f5fd28a7.png";